(function () {
  'use strict';

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /** Locale/market-aware storefront path (e.g. /en-us/cart/add.js). */
  function bhPath(path) {
    var root = (window.__BH && window.__BH.routes && window.__BH.routes.root) || '/';
    if (!root) root = '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    var clean = String(path || '').replace(/^\//, '');
    return root + clean;
  }

  function bhProductJsUrl(handle) {
    return bhPath('products/' + encodeURIComponent(handle) + '.js');
  }

  function bhNormalizeImageUrl(img) {
    if (!img) return '';
    if (typeof img === 'string') return img.indexOf('//') === 0 ? 'https:' + img : img;
    if (img.src) return bhNormalizeImageUrl(img.src);
    if (img.url) return bhNormalizeImageUrl(img.url);
    return '';
  }

  function bhNormalizeTags(tags) {
    if (!tags) return [];
    if (Array.isArray(tags)) return tags;
    return String(tags)
      .split(',')
      .map(function (t) {
        return t.trim();
      })
      .filter(Boolean);
  }

  function bhOptionNames(options) {
    if (!options || !options.length) return [];
    return options.map(function (opt) {
      if (opt == null) return '';
      if (typeof opt === 'string') return opt;
      return opt.name || String(opt);
    });
  }

  var SUPPORT_HINTS = {
    light: 'Gentle compression for everyday shaping and light control.',
    mid: 'Balanced compression for daily wear and a smoother silhouette.',
    strong: 'High compression for maximum sculpting and firm hold.',
    max: 'Maximum compression for advanced shaping and post-surgical support.',
    custom: 'Compression level for this garment.'
  };

  function escapeHtmlLite(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeSupportFromText(text) {
    var t = String(text || '').toLowerCase().trim();
    if (!t) return null;
    if (
      t.indexOf('maximum') !== -1 ||
      t.indexOf('max support') !== -1 ||
      t.indexOf('stage 4') !== -1 ||
      t.indexOf('stage4') !== -1
    ) {
      return { label: 'Maximum Support', tier: 'max', meterLevel: 4 };
    }
    if (
      t.indexOf('strong') !== -1 ||
      t.indexOf('stage 3') !== -1 ||
      t.indexOf('stage3') !== -1 ||
      t.indexOf('high') !== -1 ||
      t.indexOf('extra firm') !== -1 ||
      (t.indexOf('firm') !== -1 && t.indexOf('mid') === -1 && t.indexOf('light') === -1)
    ) {
      return { label: 'Strong Support', tier: 'strong', meterLevel: 3 };
    }
    if (
      t.indexOf('mid') !== -1 ||
      t.indexOf('medium') !== -1 ||
      t.indexOf('moderate') !== -1 ||
      t.indexOf('stage 2') !== -1 ||
      t.indexOf('stage2') !== -1
    ) {
      return { label: 'Mid Support', tier: 'mid', meterLevel: 2 };
    }
    if (
      t.indexOf('light') !== -1 ||
      t.indexOf('soft') !== -1 ||
      t.indexOf('low') !== -1 ||
      t.indexOf('stage 1') !== -1 ||
      t.indexOf('stage1') !== -1
    ) {
      return { label: 'Light Support', tier: 'light', meterLevel: 1 };
    }
    if (t.indexOf('support') !== -1 || t.indexOf('compression') !== -1 || t.indexOf('stage') !== -1) {
      return { label: text, tier: 'custom', meterLevel: 2 };
    }
    return null;
  }

  function resolveSupportFromTags(tags) {
    if (!tags || !tags.length) return null;
    for (var i = 0; i < tags.length; i += 1) {
      var tagDown = String(tags[i]).toLowerCase().trim();
      if (tagDown === 'expert support' || tagDown === 'post-surgical support') continue;
      var fromTag = normalizeSupportFromText(tagDown);
      if (fromTag) {
        if (fromTag.tier === 'custom' && tagDown.indexOf('support') === -1 && tagDown.indexOf('compression') === -1) {
          fromTag.label = String(tags[i]);
        }
        return fromTag;
      }
    }
    return null;
  }

  function resolveSupportFromTitle(title) {
    var titleDown = String(title || '').toLowerCase();
    if (titleDown.indexOf('stage 4') !== -1) {
      return { label: 'Maximum Support', tier: 'max', meterLevel: 4 };
    }
    if (titleDown.indexOf('stage 3') !== -1) {
      return { label: 'Strong Support', tier: 'strong', meterLevel: 3 };
    }
    if (titleDown.indexOf('stage 2') !== -1) {
      return { label: 'Mid Support', tier: 'mid', meterLevel: 2 };
    }
    if (titleDown.indexOf('stage 1') !== -1) {
      return { label: 'Light Support', tier: 'light', meterLevel: 1 };
    }
    return null;
  }

  function resolveSupportStrength(opts) {
    opts = opts || {};
    var fromText = normalizeSupportFromText(opts.text);
    if (fromText) {
      fromText.hint = SUPPORT_HINTS[fromText.tier] || SUPPORT_HINTS.custom;
      return fromText;
    }
    var fromTags = resolveSupportFromTags(opts.tags);
    if (fromTags) {
      fromTags.hint = SUPPORT_HINTS[fromTags.tier] || SUPPORT_HINTS.custom;
      return fromTags;
    }
    var fromTitle = resolveSupportFromTitle(opts.title);
    if (fromTitle) {
      fromTitle.hint = SUPPORT_HINTS[fromTitle.tier] || SUPPORT_HINTS.custom;
      return fromTitle;
    }
    return null;
  }

  function updateSupportBlock(el, result) {
    if (!el) return;
    if (!result || !result.label) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    el.setAttribute('data-support-tier', result.tier);
    el.setAttribute('data-support-label', result.label);
    var badge = el.querySelector('.bh-support-badge');
    if (badge) {
      badge.textContent = result.label;
      badge.className = 'bh-support-badge bh-support-badge--' + result.tier;
    }
    var bars = el.querySelectorAll('.bh-support-meter__bar');
    bars.forEach(function (bar, idx) {
      bar.classList.toggle('is-active', idx < (result.meterLevel || 2));
    });
    var hint = el.querySelector('.bh-support-block__hint');
    if (hint) hint.textContent = result.hint || SUPPORT_HINTS.custom;
  }

  function supportBadgeHtml(result, style) {
    if (!result || !result.label) return '';
    style = style || 'inline';
    var tier = result.tier || 'custom';
    var label = escapeHtmlLite(result.label);
    if (style === 'card') {
      return (
        '<span class="bh-product-card__badge"><span class="bh-product-card__badge-inner bh-product-card__badge-inner--support bh-support-badge bh-support-badge--' +
        tier +
        '">' +
        label +
        '</span></span>'
      );
    }
    return (
      '<span class="bh-support-badge bh-support-badge--' +
      tier +
      ' bh-support-badge--' +
      style +
      '">' +
      label +
      '</span>'
    );
  }

  window.__BH = window.__BH || {};
  window.__BH.resolveSupportStrength = resolveSupportStrength;
  window.__BH.updateSupportBlock = updateSupportBlock;
  window.__BH.supportBadgeHtml = supportBadgeHtml;

  /* Mobile nav */
  qsa(document, '[data-mobile-nav-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-mobile-nav-open');
      var panel = id && document.getElementById(id);
      if (panel) panel.classList.add('is-open');
    });
  });
  qsa(document, '[data-mobile-nav-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.closest('.bh-mobile-panel');
      if (panel) panel.classList.remove('is-open');
    });
  });

  /* Header search drawer (Shapellx-style icon toggle) */
  (function initSearchDrawer() {
    var drawer = qs(document, '[data-search-drawer]');
    if (!drawer) return;
    var toggles = qsa(document, '[data-search-toggle]');
    var closes = qsa(document, '[data-search-close]');
    var input = qs(drawer, '[data-search-drawer-input]');

    function setOpen(open) {
      if (open) {
        drawer.removeAttribute('hidden');
        toggles.forEach(function (t) {
          t.setAttribute('aria-expanded', 'true');
        });
        if (input) {
          setTimeout(function () {
            input.focus();
          }, 30);
        }
      } else {
        drawer.setAttribute('hidden', '');
        toggles.forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
        });
      }
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = !drawer.hasAttribute('hidden');
        setOpen(!isOpen);
      });
    });
    closes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOpen(false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) setOpen(false);
    });
  })();

  /* Scroll to top */
  qsa(document, '[data-scroll-top]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  /* Awards carousel progress bar */
  qsa(document, '.bh-awards__carousel[data-scroll-carousel]').forEach(function (root) {
    var track = qs(root, '[data-scroll-track]');
    var bar = qs(root, '[data-awards-progress]');
    if (!track || !bar) return;
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var pct = max > 0 ? (track.scrollLeft / max) * 100 : 0;
      bar.style.width = Math.max(20, Math.min(100, 20 + pct * 0.8)) + '%';
    }
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  });

  /* Hero slideshow — aspect ratio follows active slide image */
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }
  function heroSlideImg(slide) {
    if (!slide) return null;
    var pic = qs(slide, 'picture');
    return pic ? qs(pic, 'img') : qs(slide, 'img');
  }
  function syncHeroAspect(root) {
    var hero = qs(root, '.bh-hero');
    if (!hero) return;
    var active = qs(root, '.bh-hero__slide.is-active');
    var img = heroSlideImg(active);
    function apply() {
      if (!img || !img.naturalWidth || !img.naturalHeight) {
        hero.style.aspectRatio = '';
        hero.classList.remove('bh-hero--sized');
        return;
      }
      hero.style.aspectRatio = String(img.naturalWidth) + ' / ' + String(img.naturalHeight);
      hero.classList.add('bh-hero--sized');
    }
    if (img && !img.complete) {
      img.addEventListener('load', apply, { once: true });
      img.addEventListener('error', apply, { once: true });
    }
    apply();
  }
  qsa(document, '[data-hero]').forEach(function (root) {
    var slides = qsa(root, '[data-hero-slide]');
    var dots = qsa(root, '[data-hero-dot]');
    var prev = qs(root, '[data-hero-prev]');
    var next = qs(root, '[data-hero-next]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoTimer = null;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        var active = j === i;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (s.matches('a')) s.tabIndex = active ? 0 : -1;
      });
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
        d.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
      syncHeroAspect(root);
    }
    function stopAuto() {
      if (autoTimer) window.clearInterval(autoTimer);
      autoTimer = null;
    }
    function startAuto() {
      stopAuto();
      if (reduceMotion || slides.length <= 1 || document.hidden) return;
      autoTimer = window.setInterval(function () { show(i + 1); }, 6000);
    }
    if (slides.length <= 1) {
      show(0);
      syncHeroAspect(root);
      window.addEventListener(
        'resize',
        debounce(function () {
          syncHeroAspect(root);
        }, 120)
      );
      return;
    }
    show(0);
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () { show(j); });
    });
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    root.addEventListener('focusin', stopAuto);
    root.addEventListener('focusout', startAuto);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAuto();
      else startAuto();
    });
    window.addEventListener(
      'resize',
      debounce(function () {
        syncHeroAspect(root);
      }, 120)
    );
    startAuto();
  });

  /* Announcement bar */
  qsa(document, '[data-announcement]').forEach(function (root) {
    var items = qsa(root, '[data-announcement-item]');
    var prev = qs(root, '[data-announcement-prev]');
    var next = qs(root, '[data-announcement-next]');
    var label = qs(root, '[data-announcement-label]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0;
    function show(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (el, j) {
        el.hidden = j !== i;
      });
      if (label) label.textContent = items[i] ? items[i].textContent.trim() : '';
    }
    if (!items.length) return;
    show(0);
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    if (!reduceMotion) setInterval(function () { show(i + 1); }, 4500);
  });

  /* Horizontal scroll buttons */
  qsa(document, '[data-scroll-carousel]').forEach(function (root) {
    var track = qs(root, '[data-scroll-track]');
    var left = qs(root, '[data-scroll-left]');
    var right = qs(root, '[data-scroll-right]');
    if (!track) return;
    function scrollBy(dir) {
      var amount = track.clientWidth * 0.8;
      track.scrollBy({ left: dir === 'left' ? -amount : amount, behavior: 'smooth' });
    }
    if (left) left.addEventListener('click', function () { scrollBy('left'); });
    if (right) right.addEventListener('click', function () { scrollBy('right'); });
  });

  qsa(document, '[data-brands-scroll-left]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-brands-wrap]');
      var track = wrap && qs(wrap, '[data-brands-scroll]');
      if (track) track.scrollBy({ left: -track.clientWidth * 0.6, behavior: 'smooth' });
    });
  });
  qsa(document, '[data-brands-scroll-right]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-brands-wrap]');
      var track = wrap && qs(wrap, '[data-brands-scroll]');
      if (track) track.scrollBy({ left: track.clientWidth * 0.6, behavior: 'smooth' });
    });
  });

  /* Product share (native Web Share API or fallback menu) */
  qsa(document, '[data-product-share]').forEach(function (root) {
    var toggle = qs(root, '[data-product-share-toggle]');
    var menu = qs(root, '[data-product-share-menu]');
    if (!toggle || !menu) return;
    var url = root.getAttribute('data-share-url') || window.location.href;
    var title = root.getAttribute('data-share-title') || document.title;
    var feedback = qs(root, '[data-share-feedback]');
    var fb = qs(menu, '[data-share-facebook]');
    var tw = qs(menu, '[data-share-twitter]');
    var pin = qs(menu, '[data-share-pinterest]');
    var wa = qs(menu, '[data-share-whatsapp]');
    var em = qs(menu, '[data-share-email]');
    var copyBtn = qs(menu, '[data-share-copy]');
    var docClose = null;

    function populateLinks() {
      var u = encodeURIComponent(url);
      var t = encodeURIComponent(title);
      if (fb) fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + u;
      if (tw) tw.href = 'https://twitter.com/intent/tweet?url=' + u + '&text=' + t;
      if (pin) pin.href = 'https://www.pinterest.com/pin/create/button/?url=' + u + '&description=' + t;
      if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url);
    }

    function closeMenu() {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (docClose) {
        document.removeEventListener('click', docClose);
        docClose = null;
      }
    }

    function openMenu() {
      populateLinks();
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      if (feedback) feedback.hidden = true;
      docClose = function (e) {
        if (!root.contains(e.target)) closeMenu();
      };
      setTimeout(function () {
        document.addEventListener('click', docClose);
      }, 0);
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
        navigator
          .share({ title: title, text: title, url: url })
          .catch(function () {});
        return;
      }
      if (menu.hidden) openMenu();
      else closeMenu();
    });

    if (em) {
      em.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href =
          'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
        closeMenu();
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        function showCopied() {
          if (feedback) {
            feedback.hidden = false;
            setTimeout(function () {
              if (feedback) feedback.hidden = true;
            }, 2000);
          }
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showCopied).catch(showCopied);
        } else {
          try {
            var ta = document.createElement('textarea');
            ta.value = url;
            ta.setAttribute('readonly', '');
            ta.style.position = 'absolute';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            showCopied();
          } catch (err) {
            window.prompt('Copy this link:', url);
          }
        }
        closeMenu();
      });
    }

    qsa(menu, 'a[data-share-facebook], a[data-share-twitter], a[data-share-pinterest], a[data-share-whatsapp]').forEach(
      function (a) {
        a.addEventListener('click', function () {
          closeMenu();
        });
      }
    );
  });

  /* Accordion */
  qsa(document, '[data-accordion-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-accordion-item]');
      if (!item) return;
      var open = item.classList.contains('is-open');
      var group = item.closest('[data-accordion]');
      if (group && group.getAttribute('data-accordion-single') === 'true') {
        qsa(group, '[data-accordion-item].is-open').forEach(function (o) {
          o.classList.remove('is-open');
        });
      }
      if (!open) item.classList.add('is-open');
      else item.classList.remove('is-open');
    });
  });

  function setCardImage(img, url, alt) {
    if (!img || !url) return;
    img.src = url;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    if (alt != null && alt !== '') img.alt = alt;
  }

  function ensureHoverImage(card, mainImg) {
    var hoverImg = qs(card, '[data-card-image-hover]');
    if (hoverImg) return hoverImg;
    var media = qs(card, '.bh-product-card__media');
    if (!media || !mainImg) return null;
    hoverImg = document.createElement('img');
    hoverImg.className = 'bh-product-card__img2';
    hoverImg.setAttribute('data-card-image-hover', '');
    hoverImg.loading = 'lazy';
    hoverImg.width = 800;
    hoverImg.height = 1000;
    media.appendChild(hoverImg);
    return hoverImg;
  }

  function findVariantByColor(product, colorName, colorIndex) {
    if (!product || !product.variants || colorIndex < 0 || isNaN(colorIndex)) return null;
    var matches = product.variants.filter(function (v) {
      var opts = v.options || [];
      return String(opts[colorIndex]) === String(colorName);
    });
    var available = matches.filter(function (v) {
      return v.available;
    });
    return available[0] || matches[0] || null;
  }

  function findHoverImageForVariant(product, mainSrc) {
    if (!product || !product.images || !product.images.length) return '';
    var mainBase = (mainSrc || '').split('?')[0];
    for (var i = 0; i < product.images.length; i++) {
      var src = product.images[i];
      if (!src) continue;
      if (src.split('?')[0] !== mainBase) return src;
    }
    return '';
  }

  function loadProductJs(card) {
    if (card._bhProductJs) return card._bhProductJs;
    var handle = card.getAttribute('data-product-handle');
    if (!handle) return null;
    card._bhProductJs = fetch(bhProductJsUrl(handle))
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
    return card._bhProductJs;
  }

  function initProductCardSwatches(card) {
    if (card.getAttribute('data-card-swatch-init') === 'true') return;
    var swatches = qsa(card, '[data-card-swatch]');
    if (!swatches.length) return;
    card.setAttribute('data-card-swatch-init', 'true');

    var mainImg = qs(card, '[data-card-image-main]');
    var hoverImg = qs(card, '[data-card-image-hover]');
    var priceEl = qs(card, '[data-card-price]');
    var compareEl = qs(card, '[data-card-compare]');
    var badgeEl = qs(card, '[data-card-badge]');
    var linkEls = qsa(card, '[data-card-link]');
    var variantInput = qs(card, '[data-variant-input]') || qs(card, 'input[name="id"]');
    var colorLabelEl = qs(card, '[data-card-color-label]');
    var colorIndex = parseInt(card.getAttribute('data-color-option-index'), 10);

    function applySwatch(btn, useProductApi) {
      if (!btn) return;
      swatches.forEach(function (sw) {
        var isActive = sw === btn;
        sw.classList.toggle('is-selected', isActive);
        sw.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      var image = btn.getAttribute('data-image');
      var imageAlt = btn.getAttribute('data-image-alt') || '';
      if (mainImg && image) {
        setCardImage(mainImg, image, imageAlt);
      }

      var hover = btn.getAttribute('data-hover-image');
      var hoverTarget = hoverImg || ensureHoverImage(card, mainImg);
      if (hoverTarget && hover) {
        setCardImage(hoverTarget, hover, imageAlt);
      }

      var price = btn.getAttribute('data-price');
      if (priceEl && price) {
        priceEl.textContent = price;
      }

      var compare = btn.getAttribute('data-compare');
      if (compareEl) {
        compareEl.hidden = !compare;
        compareEl.textContent = compare || '';
      }
      if (priceEl) {
        priceEl.classList.toggle('bh-product-card__price--sale', !!compare);
      }

      var saveMoney = btn.getAttribute('data-save');
      var discountPct = btn.getAttribute('data-discount');
      if (badgeEl) {
        var badgeInner = qs(badgeEl, '.bh-product-card__badge-inner') || qs(badgeEl, '[data-card-save-amount]');
        var badgeLabel = discountPct ? discountPct + '% off' : saveMoney;
        if (compare && badgeLabel) {
          badgeEl.hidden = false;
          if (badgeInner) badgeInner.textContent = badgeLabel;
          else badgeEl.textContent = badgeLabel;
        } else {
          badgeEl.hidden = true;
        }
      }

      var variantId = btn.getAttribute('data-variant-id');
      if (variantInput && variantId) {
        variantInput.value = variantId;
      }
      var variantUrl = btn.getAttribute('data-variant-url');
      if (variantUrl) {
        linkEls.forEach(function (a) {
          a.setAttribute('href', variantUrl);
        });
      }
      var colorName = btn.getAttribute('data-color-name');
      if (colorLabelEl && colorName) {
        var prefix = colorLabelEl.textContent.split(':')[0] || 'Color';
        colorLabelEl.textContent = prefix.trim() + ': ' + colorName;
      }

      if (!useProductApi || !mainImg) return;
      var activeColor = colorName;
      var productDataPromise = loadProductJs(card);
      if (!productDataPromise) return;
      productDataPromise.then(function (product) {
        if (!product || !activeColor) return;
        var variant = findVariantByColor(product, activeColor, colorIndex);
        if (!variant || !variant.featured_image || !variant.featured_image.src) return;
        setCardImage(mainImg, variant.featured_image.src, variant.featured_image.alt || imageAlt);
        var hoverFromApi =
          btn.getAttribute('data-hover-image') || findHoverImageForVariant(product, variant.featured_image.src);
        var hoverNode = hoverImg || ensureHoverImage(card, mainImg);
        if (hoverNode && hoverFromApi) {
          setCardImage(hoverNode, hoverFromApi, variant.featured_image.alt || imageAlt);
        }
        if (variant.id && linkEls.length) {
          var fullUrl = product.url + '?variant=' + variant.id;
          linkEls.forEach(function (a) {
            a.setAttribute('href', fullUrl);
          });
        }
      });
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        applySwatch(btn, true);
      });
    });

    var initial = swatches.find(function (sw) {
      return sw.classList.contains('is-selected');
    });
    if (initial && mainImg) {
      applySwatch(initial, false);
    }
  }

  function initAllProductCardSwatches(root) {
    qsa(root || document, '[data-product-card]').forEach(initProductCardSwatches);
  }

  /* Product gallery + variant image sync */
  qsa(document, '[data-product-gallery]').forEach(function (root) {
    var thumbs = qsa(root, '[data-gallery-thumb]');
    var dots = qsa(root, '[data-gallery-dot]');
    var imgs = qsa(root, '[data-gallery-image]');
    var main = qs(root, '[data-gallery-main]');
    var prev = qs(root, '[data-gallery-prev]');
    var next = qs(root, '[data-gallery-next]');
    var currentIndex = 0;
    function show(n) {
      var i = Math.max(0, Math.min(n, imgs.length - 1));
      currentIndex = i;
      imgs.forEach(function (slide, j) {
        slide.hidden = j !== i;
      });
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-active', j === i);
        t.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
      });
    }
    root._bhGalleryShow = show;
    thumbs.forEach(function (t, j) {
      t.addEventListener('click', function () {
        show(j);
      });
    });
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () {
        show(j);
      });
    });
    if (prev) {
      prev.addEventListener('click', function () {
        show(currentIndex - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        show(currentIndex + 1);
      });
    }

    if (main) {
      var touchStartX = 0;
      var touchStartY = 0;
      var wheelLock = false;
      main.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || !e.touches.length) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        },
        { passive: true }
      );
      main.addEventListener(
        'touchend',
        function (e) {
          if (!e.changedTouches || !e.changedTouches.length) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy)) return;
          if (dx < 0) show(currentIndex + 1);
          else show(currentIndex - 1);
        },
        { passive: true }
      );
      main.addEventListener(
        'wheel',
        function (e) {
          if (Math.abs(e.deltaY) < 12 && Math.abs(e.deltaX) < 12) return;
          if (wheelLock) return;
          wheelLock = true;
          setTimeout(function () {
            wheelLock = false;
          }, 180);
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
            if (e.deltaX > 0) show(currentIndex + 1);
            else show(currentIndex - 1);
            return;
          }
          if (e.deltaY > 0) show(currentIndex + 1);
          else show(currentIndex - 1);
        },
        { passive: true }
      );
    }

    if (imgs.length) show(0);
  });

  document.addEventListener('variant:change', function (e) {
    var detail = e.detail;
    if (!detail) return;
    var root = qs(document, '[data-product-gallery]');
    if (!root || !root._bhGalleryShow) return;
    var imgs = qsa(root, '[data-gallery-image]');
    if (!imgs.length) return;
    var mid = detail.featured_media && detail.featured_media.id;
    if (mid) {
      var found = -1;
      imgs.forEach(function (el, j) {
        var elId = el.getAttribute('data-media-id');
        if (elId && parseInt(elId, 10) === mid) found = j;
      });
      if (found >= 0) {
        root._bhGalleryShow(found);
        return;
      }
    }
    var url = detail.featured_media && detail.featured_media.preview_image && detail.featured_media.preview_image.src;
    if (!url) return;
    var base = url.split('?')[0];
    imgs.forEach(function (wrap, j) {
      var img = qs(wrap, 'img');
      if (img && img.currentSrc && img.currentSrc.indexOf(base) !== -1) root._bhGalleryShow(j);
      else if (img && img.src && img.src.indexOf(base) !== -1) root._bhGalleryShow(j);
    });
  });

  function bhVariantOptions(v) {
    if (!v) return [];
    if (Array.isArray(v.options) && v.options.length) return v.options;
    var o = [];
    if (v.option1) o.push(v.option1);
    if (v.option2) o.push(v.option2);
    if (v.option3) o.push(v.option3);
    return o;
  }

  function initBhProduct(root) {
    var jsonEl = qs(root, '[data-bh-product-json]');
    if (!jsonEl || !jsonEl.textContent) return;
    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }
    var currencyEl = qs(root, '[data-bh-currency]');
    var currency = (currencyEl && currencyEl.getAttribute('data-bh-currency')) || 'USD';
    var input = qs(root, '[data-variant-input]');
    var priceEl = qs(root, '[data-product-price]');
    var compareEl = qs(root, '[data-product-compare]');
    var saveEl = qs(root, '[data-product-save]');
    var submitBtn = qs(root, '[data-product-submit]');
    var stockRow = qs(root, '[data-product-stock]');
    var pills = qsa(root, '[data-variant-pill]');
    if (!pills.length) return;

    function money(cents) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency,
        }).format((cents || 0) / 100);
      } catch (err2) {
        return ((cents || 0) / 100).toFixed(2);
      }
    }

    function findVariant(selected) {
      return product.variants.find(function (v) {
        var opts = bhVariantOptions(v);
        if (opts.length !== selected.length) return false;
        return opts.every(function (o, idx) {
          return String(o) === String(selected[idx]);
        });
      });
    }

    function comboExists(optIndex, value, selected) {
      return product.variants.some(function (v) {
        var opts = bhVariantOptions(v);
        if (String(opts[optIndex]) !== String(value)) return false;
        for (var j = 0; j < selected.length; j++) {
          if (j === optIndex) continue;
          if (selected[j] != null && selected[j] !== '' && String(opts[j]) !== String(selected[j])) return false;
        }
        return true;
      });
    }

    function resolveVariant(selected, changedIndex) {
      var v = findVariant(selected);
      if (v) return v;
      v = product.variants.find(function (x) {
        if (!x.available) return false;
        var opts = bhVariantOptions(x);
        if (String(opts[changedIndex]) !== String(selected[changedIndex])) return false;
        for (var j = 0; j < changedIndex; j++) {
          if (selected[j] != null && selected[j] !== '' && String(opts[j]) !== String(selected[j])) return false;
        }
        return true;
      });
      if (v) return v;
      return product.variants.find(function (x) {
        var opts = bhVariantOptions(x);
        if (String(opts[changedIndex]) !== String(selected[changedIndex])) return false;
        for (var j = 0; j < changedIndex; j++) {
          if (selected[j] != null && selected[j] !== '' && String(opts[j]) !== String(selected[j])) return false;
        }
        return true;
      });
    }

    var selected = [];

    function updateUi(variant) {
      if (!variant || !input) return;
      input.value = String(variant.id);
      if (priceEl) priceEl.textContent = money(variant.price);
      var cmp = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !cmp;
        compareEl.textContent = cmp ? money(variant.compare_at_price) : '';
      }
      if (priceEl) priceEl.classList.toggle('bh-price--sale', !!cmp);
      if (saveEl) {
        if (cmp) {
          var save = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          saveEl.hidden = false;
          var savePrefix = (root.getAttribute('data-save-label') || 'Save').trim();
          saveEl.textContent = savePrefix + ' ' + save + '%';
        } else {
          saveEl.hidden = true;
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available
          ? submitBtn.getAttribute('data-label-add') || 'Add to bag'
          : submitBtn.getAttribute('data-label-sold') || 'Sold out';
      }
      if (stockRow) stockRow.hidden = !variant.available;

      selected = bhVariantOptions(variant).slice();

      pills.forEach(function (pill) {
        var idx = parseInt(pill.getAttribute('data-option-index'), 10);
        var val = pill.getAttribute('data-value');
        if (val == null) return;
        var isSel = String(selected[idx]) === String(val);
        pill.classList.toggle('is-selected', isSel);
        pill.setAttribute('aria-pressed', isSel ? 'true' : 'false');
        var exists = comboExists(idx, val, selected);
        pill.disabled = !exists;
      });

      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', String(variant.id));
        history.replaceState({}, '', u.toString());
      } catch (err3) {}

      document.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: { featured_media: variant.featured_media, variant: variant },
        })
      );
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        var idx = parseInt(pill.getAttribute('data-option-index'), 10);
        var val = pill.getAttribute('data-value');
        var next = selected.slice();
        next[idx] = val;
        var v = resolveVariant(next, idx);
        if (v) updateUi(v);
      });
    });

    var params = new URLSearchParams(window.location.search);
    var vid = params.get('variant');
    var initial =
      product.variants.find(function (v) {
        return String(v.id) === String(vid);
      }) ||
      (input &&
        product.variants.find(function (v) {
          return String(v.id) === String(input.value);
        })) ||
      product.selected_or_first_available_variant ||
      product.variants[0];
    if (initial) updateUi(initial);
  }

  /* Cart drawer */
  var drawer = qs(document, '[data-cart-drawer]');
  var backdrop = drawer && qs(drawer, '[data-cart-drawer-backdrop]');
  var panel = drawer && qs(drawer, '[data-cart-drawer-panel]');
  var lastActiveElement = null;

  function syncScrollLock() {
    if (!drawer || !drawer.classList.contains('is-open')) {
      document.documentElement.style.overflow = '';
    }
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function renderCart(cart) {
    var list = drawer && qs(drawer, '[data-cart-lines]');
    var empty = drawer && qs(drawer, '[data-cart-empty]');
    var hasItems = drawer && qs(drawer, '[data-cart-has-items]');
    var footer = drawer && qs(drawer, '[data-cart-footer]');
    var desc = drawer && qs(drawer, '[data-cart-desc]');
    var countEls = qsa(document, '[data-cart-count]');
    var sub = drawer && qs(drawer, '[data-cart-subtotal]');
    if (!list) return;
    var n = cart.item_count || 0;
    countEls.forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    });
    if (desc) {
      var emptyDesc = (drawer && drawer.getAttribute('data-cart-empty-desc')) || 'Your cart is empty';
      var wordOne = (drawer && drawer.getAttribute('data-cart-word-one')) || 'item';
      var wordMany = (drawer && drawer.getAttribute('data-cart-word-many')) || 'items';
      desc.textContent =
        n === 0 ? emptyDesc : n + ' ' + (n === 1 ? wordOne : wordMany);
    }
    if (n === 0) {
      list.innerHTML = '';
      if (empty) empty.classList.remove('hidden');
      if (hasItems) hasItems.classList.add('hidden');
      if (footer) footer.classList.add('hidden');
      if (sub) sub.textContent = money(0, cart.currency);
      return;
    }
    if (empty) empty.classList.add('hidden');
    if (hasItems) hasItems.classList.remove('hidden');
    if (footer) footer.classList.remove('hidden');
    list.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' +
          String(item.image).replace(/&/g, '&amp;').replace(/"/g, '&quot;') +
          '" alt="" width="80" height="96" class="w-full h-full object-cover">'
        : '';
      var supportResult = resolveSupportStrength({
        text: item.variant_title,
        title: item.product_title
      });
      var supportLine = supportResult
        ? '<p class="mt-1 mb-0">' + supportBadgeHtml(supportResult, 'inline') + '</p>'
        : '';
      return (
        '<div class="flex gap-4 pb-5 border-b border-border last:border-0" data-line-key="' +
        item.key +
        '">' +
        '<div class="w-20 h-24 bg-secondary rounded-md overflow-hidden flex-shrink-0">' +
        img +
        '</div>' +
        '<div class="flex-1 min-w-0">' +
        '<h4 class="font-medium text-sm leading-snug line-clamp-2"><a href="' +
        item.url +
        '">' +
        item.product_title +
        '</a></h4>' +
        (item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="text-xs text-muted-foreground mt-1">' +
            item.variant_title +
            '</p>'
          : '') +
        supportLine +
        '<p class="font-semibold mt-1">' +
        money(item.final_line_price, cart.currency) +
        '</p>' +
        '<div class="flex items-center justify-between mt-2">' +
        '<div class="flex items-center border border-border rounded-md">' +
        '<button type="button" class="h-7 w-7 flex items-center justify-center hover:bg-secondary" data-cart-dec="' +
        item.key +
        '">−</button>' +
        '<span class="w-8 text-center text-sm">' +
        item.quantity +
        '</span>' +
        '<button type="button" class="h-7 w-7 flex items-center justify-center hover:bg-secondary" data-cart-inc="' +
        item.key +
        '">+</button>' +
        '</div>' +
        '<button type="button" class="h-7 w-7 text-muted-foreground hover:text-destructive" data-cart-remove="' +
        item.key +
        '" aria-label="Remove"><svg class="bh-icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4h8v2M19 6v14H5V6M10 11v6M14 11v6"/></svg></button>' +
        '</div></div></div>'
      );
    }).join('');
    if (sub) sub.textContent = money(cart.total_price, cart.currency);

    var ship = drawer && qs(drawer, '[data-cart-ship]');
    if (ship) {
      var threshold = parseInt(ship.getAttribute('data-threshold-cents') || '7500', 10);
      var prefix = ship.getAttribute('data-prefix') || "You're";
      var suffix = ship.getAttribute('data-suffix') || 'away from free shipping';
      var reached = ship.getAttribute('data-reached') || "You've unlocked free shipping!";
      var msg = qs(ship, '[data-cart-ship-msg]');
      var fill = qs(ship, '[data-cart-ship-fill]');
      var remaining = Math.max(0, threshold - (cart.total_price || 0));
      var pct = threshold > 0 ? Math.min(100, Math.round(((cart.total_price || 0) * 100) / threshold)) : 0;
      if (msg) {
        msg.innerHTML =
          remaining > 0
            ? prefix + ' <strong>' + money(remaining, cart.currency) + '</strong> ' + suffix
            : '<strong>' + reached + '</strong>';
      }
      if (fill) fill.style.width = pct + '%';
    }

    qsa(list, '[data-cart-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        changeLine(b.getAttribute('data-cart-remove'), 0);
      });
    });
    qsa(list, '[data-cart-dec]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-cart-dec');
        var line = cart.items.find(function (x) { return x.key === key; });
        if (line) changeLine(key, line.quantity - 1);
      });
    });
    qsa(list, '[data-cart-inc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-cart-inc');
        var line = cart.items.find(function (x) { return x.key === key; });
        if (line) changeLine(key, line.quantity + 1);
      });
    });
  }

  function fetchCart() {
    return fetch(bhPath('cart.js')).then(function (r) { return r.json(); });
  }

  function refreshCartUi() {
    return fetchCart().then(renderCart).catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch(bhPath('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) return;
    refreshCartUi();
  });

  function openCart(prefetchedCart) {
    if (!drawer) return;
    if (document.activeElement instanceof HTMLElement) {
      lastActiveElement = document.activeElement;
    }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    function focusPanel() {
      var closeBtn = panel && qs(panel, '[data-cart-close]');
      if (closeBtn) closeBtn.focus();
      else if (panel) panel.focus();
    }
    if (prefetchedCart) {
      renderCart(prefetchedCart);
      focusPanel();
      return;
    }
    fetchCart()
      .then(renderCart)
      .finally(focusPanel);
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    syncScrollLock();
    if (lastActiveElement && document.contains(lastActiveElement)) {
      lastActiveElement.focus();
    }
  }

  qsa(document, '[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  if (backdrop) backdrop.addEventListener('click', closeCart);
  qsa(document, '[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });
  document.addEventListener('keydown', function (e) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeCart();
      return;
    }
    if (e.key !== 'Tab' || !panel) return;
    var focusables = qsa(
      panel,
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    ).filter(function (el) {
      return !el.hasAttribute('hidden') && el.offsetParent !== null;
    });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
      return;
    }
    if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
  window.addEventListener('pageshow', syncScrollLock);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) syncScrollLock();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('data-ajax-cart') !== 'true' && !form.classList.contains('bh-ajax-product-form')) return;
    e.preventDefault();
    var submitter = e.submitter;
    var restoreSubmitter =
      submitter instanceof HTMLElement &&
      (submitter.tagName === 'BUTTON' || submitter.tagName === 'INPUT');
    if (restoreSubmitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }
    var fd = new FormData(form);
    var variantId = fd.get('id');
    if (!variantId) {
      if (restoreSubmitter) {
        submitter.disabled = false;
        submitter.removeAttribute('aria-busy');
      }
      return;
    }
    fetch(bhPath('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd,
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        return r.json();
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        renderCart(cart);
        /* Product page (.bh-ajax-product-form): add in background; drawer opens only via cart icon / data-cart-open. */
        if (!form.classList.contains('bh-ajax-product-form')) {
          if (window.BluehorixonTheme && typeof window.BluehorixonTheme.closeQuickView === 'function') {
            window.BluehorixonTheme.closeQuickView();
          }
          openCart(cart);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (restoreSubmitter) {
          submitter.disabled = false;
          submitter.removeAttribute('aria-busy');
        }
      });
  });

  window.BluehorixonTheme = { openCart: openCart, closeCart: closeCart };

  function initQuickView() {
    var drawer = qs(document, '[data-quick-view-drawer]');
    if (!drawer) return;
    var panel = qs(drawer, '[data-qv-panel]');
    var bodyEl = qs(drawer, '[data-qv-body]');
    var loadingEl = qs(drawer, '[data-qv-loading]');
    var contentEl = qs(drawer, '[data-qv-content]');
    var errorEl = qs(drawer, '[data-qv-error]');
    var fallbackLink = qs(drawer, '[data-qv-fallback]');
    var currency = (window.__BH && window.__BH.currencyCode) || 'USD';
    var cache = {};
    var currentProduct = null;
    var selectedOptions = [];
    var lastFocus = null;

    var SWATCH_MAP = {
      black: '#1a1a1a',
      white: '#f5f5f5',
      nude: '#e0b892',
      'nude 1': '#e0b892',
      'nude 2': '#e0b892',
      'flesh color': '#e0b892',
      flesh: '#e0b892',
      skin: '#e0b892',
      beige: '#d9c4a5',
      sand: '#d9c4a5',
      tan: '#d9c4a5',
      geige: '#d9c4a5',
      greige: '#d9c4a5',
      taupe: '#d9c4a5',
      ivory: '#f3efe3',
      cream: '#f3efe3',
      'off white': '#f3efe3',
      'off-white': '#f3efe3',
      'cream yellow': '#f3efe3',
      brown: '#8b5a2b',
      cocoa: '#8b5a2b',
      chocolate: '#8b5a2b',
      'cameo brown': '#a67b5b',
      red: '#d32f2f',
      'shrimp red': '#e57373',
      wine: '#722f37',
      burgundy: '#722f37',
      berry: '#9b1b30',
      carmine: '#9b1b30',
      pink: '#e8a0b0',
      'dusty pink': '#e8a0b0',
      rose: '#e8a0b0',
      fuchsia: '#c2185b',
      apricot: '#fbceb1',
      yellow: '#f0d060',
      blue: '#3d6aa8',
      navy: '#1b2a4a',
      'navy blue': '#1b2a4a',
      green: '#3d7a4a',
      olive: '#6b7c3f',
      teal: '#0d7377',
      'deep teal': '#0d7377',
      purple: '#7b5ea7',
      gray: '#9e9e9e',
      grey: '#9e9e9e',
      charcoal: '#4a4a4a',
      bronze: '#a67c52',
      suit: '#2c3e50',
      'black and nude': 'linear-gradient(135deg,#1a1a1a 50%,#e0b892 50%)',
      '3color single': 'linear-gradient(90deg,#1a1a1a 0 33%,#e0b892 33% 66%,#d32f2f 66% 100%)',
      '3color  single': 'linear-gradient(90deg,#1a1a1a 0 33%,#e0b892 33% 66%,#d32f2f 66% 100%)',
      'zebra print': 'repeating-linear-gradient(45deg,#111 0 4px,#eee 4px 8px)',
      zebra: 'repeating-linear-gradient(45deg,#111 0 4px,#eee 4px 8px)'
    };

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function swatchColor(name) {
      var key = String(name || '').toLowerCase().trim();
      if (SWATCH_MAP[key]) return SWATCH_MAP[key];
      var keys = Object.keys(SWATCH_MAP).sort(function (a, b) {
        return b.length - a.length;
      });
      for (var i = 0; i < keys.length; i++) {
        if (key.indexOf(keys[i]) !== -1) return SWATCH_MAP[keys[i]];
      }
      return '#c8c4bc';
    }

    function isColorOption(name) {
      var n = String(name || '').toLowerCase();
      return n.indexOf('color') !== -1 || n.indexOf('colour') !== -1;
    }

    function findVariant(product) {
      if (!product || !product.variants) return null;
      return (
        product.variants.find(function (v) {
          return selectedOptions.every(function (val, i) {
            return String(v['option' + (i + 1)]) === String(val);
          });
        }) || product.variants[0]
      );
    }

    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      document.body.style.overflow = open ? 'hidden' : '';
      if (open && panel) {
        panel.focus();
      } else if (!open && lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    function closeQuickView() {
      setOpen(false);
    }

    function supportFromTags(product) {
      var tags = product.tags || [];
      var label = '';
      var level = 3;
      for (var i = 0; i < tags.length; i++) {
        var t = String(tags[i] || '').toLowerCase();
        if (t.indexOf('maximum support') !== -1 || t.indexOf('max support') !== -1) {
          label = 'Maximum Support';
          level = 5;
          break;
        }
        if (t.indexOf('strong support') !== -1 || t.indexOf('super strong') !== -1) {
          label = 'Strong Support';
          level = 4;
          break;
        }
        if (t.indexOf('mid support') !== -1 || t.indexOf('medium support') !== -1) {
          label = 'Mid Support';
          level = 3;
          break;
        }
        if (t.indexOf('light support') !== -1) {
          label = 'Light Support';
          level = 2;
          break;
        }
      }
      return label ? { label: label, level: level } : null;
    }

    function renderProduct(product) {
      currentProduct = product;
      selectedOptions = (product.options || []).map(function (opt, i) {
        var firstAvailable = product.variants.find(function (v) {
          return v.available;
        });
        return firstAvailable ? firstAvailable['option' + (i + 1)] : (opt.values && opt.values[0]) || '';
      });

      function paint() {
        var variant = findVariant(product);
        if (!variant) return;
        var img =
          (variant.featured_image && variant.featured_image.src) ||
          product.featured_image ||
          (product.images && product.images[0]) ||
          '';
        img = bhNormalizeImageUrl(img);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var detailsUrl = product.url + (variant.id ? '?variant=' + variant.id : '');
        var support = supportFromTags(product);
        var installmentCents = Math.max(1, Math.round(variant.price / 4));

        var optionsHtml = (product.options || [])
          .map(function (opt, optIndex) {
            if (product.options.length === 1 && opt.name === 'Title') return '';
            var isColor = isColorOption(opt.name);
            var values = (opt.values || [])
              .map(function (val) {
                var available = product.variants.some(function (v) {
                  if (!v.available) return false;
                  return selectedOptions.every(function (sel, i) {
                    if (i === optIndex) return String(v['option' + (i + 1)]) === String(val);
                    return String(v['option' + (i + 1)]) === String(sel);
                  });
                });
                var active = String(selectedOptions[optIndex]) === String(val);
                if (isColor) {
                  return (
                    '<button type="button" class="bh-qv__swatch' +
                    (active ? ' is-active' : '') +
                    '" style="--swatch:' +
                    swatchColor(val) +
                    '" data-qv-option="' +
                    optIndex +
                    '" data-qv-value="' +
                    String(val).replace(/"/g, '&quot;') +
                    '" aria-label="' +
                    String(val).replace(/"/g, '&quot;') +
                    '"' +
                    (available ? '' : ' disabled') +
                    '></button>'
                  );
                }
                return (
                  '<button type="button" class="bh-qv__size' +
                  (active ? ' is-active' : '') +
                  '" data-qv-option="' +
                  optIndex +
                  '" data-qv-value="' +
                  String(val).replace(/"/g, '&quot;') +
                  '"' +
                  (available ? '' : ' disabled') +
                  '>' +
                  val +
                  '</button>'
                );
              })
              .join('');
            return (
              '<div class="bh-qv__opt">' +
              '<span class="bh-qv__opt-label">' +
              opt.name +
              ': ' +
              selectedOptions[optIndex] +
              '</span>' +
              '<div class="bh-qv__opt-values">' +
              values +
              '</div></div>'
            );
          })
          .join('');

        var supportHtml = '';
        if (support) {
          var bars = '';
          for (var b = 1; b <= 5; b++) {
            bars += '<span class="' + (b <= support.level ? 'is-on' : '') + '"></span>';
          }
          supportHtml =
            '<div class="bh-qv__support">' +
            '<span class="bh-qv__support-meter" aria-hidden="true">' +
            bars +
            '</span>' +
            '<span>' +
            support.label +
            '</span></div>';
        }

        contentEl.innerHTML =
          '<div class="bh-qv__scroll">' +
          '<div class="bh-qv__summary">' +
          '<div class="bh-qv__thumb">' +
          (img
            ? '<img src="' +
              img +
              '" alt="' +
              String(product.title || '').replace(/"/g, '&quot;') +
              '" width="180" height="180">'
            : '') +
          '</div>' +
          '<div class="bh-qv__summary-copy">' +
          (product.vendor ? '<p class="bh-qv__vendor">' + product.vendor + '</p>' : '') +
          '<h3 class="bh-qv__title">' +
          product.title +
          '</h3>' +
          '<div class="bh-qv__price-row">' +
          (onSale ? '<span class="bh-qv__compare">' + formatMoney(variant.compare_at_price) + '</span>' : '') +
          '<span class="bh-qv__price">' +
          formatMoney(variant.price) +
          '</span></div></div></div>' +
          supportHtml +
          '<div class="bh-qv__options">' +
          optionsHtml +
          '</div>' +
          '<a class="bh-qv__guide" href="' +
          detailsUrl +
          '#size-guide">' +
          '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 8h18v8H3zM7 8v3M11 8v2M15 8v3M19 8v2"/></svg>' +
          'Size & Fit Guide</a>' +
          '</div>' +
          '<div class="bh-qv__foot">' +
          '<form method="post" action="' +
          bhPath('cart/add') +
          '" data-ajax-cart="true" class="bh-qv__form">' +
          '<input type="hidden" name="id" value="' +
          variant.id +
          '" data-qv-variant-id>' +
          '<input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="bh-qv__atc" data-qv-atc' +
          (variant.available ? '' : ' disabled') +
          '>' +
          (variant.available ? 'ADD TO CART' : 'Sold out') +
          '</button></form>' +
          (variant.available
            ? '<a class="bh-qv__shop-pay" href="' +
              bhPath('cart/' + variant.id + ':1') +
              '">Buy with <strong>Shop</strong></a>'
            : '') +
          '<p class="bh-qv__pay-note">From <strong>' +
          formatMoney(installmentCents) +
          '/month</strong> or 0% interest with Shop Pay.</p>' +
          '<div class="bh-qv__promise">' +
          '<span class="bh-qv__promise-badge">30<br>DAYS</span>' +
          '<div><p class="bh-qv__promise-title">Our Main Promise</p>' +
          '<p class="bh-qv__promise-line">30-Day Fit Guarantee</p>' +
          '<p class="bh-qv__promise-line">Easy Exchange & No-Hassle Returns</p></div></div>' +
          '<a class="bh-qv__details" href="' +
          detailsUrl +
          '">View details</a>' +
          '</div>';

        qsa(contentEl, '[data-qv-option]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var idx = parseInt(btn.getAttribute('data-qv-option'), 10);
            var val = btn.getAttribute('data-qv-value');
            selectedOptions[idx] = val;
            paint();
          });
        });
      }

      paint();
      if (loadingEl) loadingEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
      if (contentEl) contentEl.hidden = false;
    }

    function openQuickView(handle, trigger) {
      if (!handle) return;
      lastFocus = trigger || document.activeElement;
      setOpen(true);
      if (loadingEl) loadingEl.hidden = false;
      if (contentEl) {
        contentEl.hidden = true;
        contentEl.innerHTML = '';
      }
      if (errorEl) errorEl.hidden = true;
      if (fallbackLink) fallbackLink.href = bhPath('products/' + handle);

      var load = cache[handle]
        ? Promise.resolve(cache[handle])
        : fetch(bhProductJsUrl(handle))
            .then(function (r) {
              if (!r.ok) throw new Error('load_failed');
              return r.json();
            })
            .then(function (product) {
              cache[handle] = product;
              return product;
            });

      load
        .then(function (product) {
          renderProduct(product);
        })
        .catch(function () {
          if (loadingEl) loadingEl.hidden = true;
          if (contentEl) contentEl.hidden = true;
          if (errorEl) errorEl.hidden = false;
        });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) {
        var card = btn.closest('[data-product-card]');
        handle = card && card.getAttribute('data-product-handle');
      }
      openQuickView(handle, btn);
    });

    qsa(drawer, '[data-qv-close], [data-qv-backdrop]').forEach(function (el) {
      el.addEventListener('click', closeQuickView);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeQuickView();
      }
    });

    /* Mobile: reveal Shop on press/hover of card */
    qsa(document, '[data-product-card]').forEach(function (card) {
      var clearTimer = null;
      card.addEventListener('touchstart', function () {
        qsa(document, '[data-product-card].is-touch-active').forEach(function (other) {
          if (other !== card) other.classList.remove('is-touch-active');
        });
        card.classList.add('is-touch-active');
        if (clearTimer) clearTimeout(clearTimer);
      }, { passive: true });
      card.addEventListener('touchend', function () {
        clearTimer = setTimeout(function () {
          card.classList.remove('is-touch-active');
        }, 2500);
      }, { passive: true });
    });

    window.BluehorixonTheme.openQuickView = openQuickView;
    window.BluehorixonTheme.closeQuickView = closeQuickView;
  }

  function initBhPredictiveSearch() {
    var baseUrl = (window.__BH && window.__BH.predictiveSearchUrl) || '';
    if (!baseUrl) return;
    var currency = (window.__BH && window.__BH.currencyCode) || 'USD';
    var wraps = qsa(document, '[data-bh-predictive]');
    if (!wraps.length) return;

    function formatMoney(decimal) {
      var n = parseFloat(String(decimal), 10);
      if (isNaN(n)) return '';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(n);
      } catch (e2) {
        return String(n);
      }
    }
    function escapeHtml(s) {
      return String(s || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
    function escapeAttr(s) {
      return String(s || '').replace(/"/g, '&quot;');
    }
    function closeWrap(wrap) {
      var panel = qs(wrap, '[data-bh-predictive-panel]');
      var input = qs(wrap, '[data-bh-predictive-input]');
      if (panel) {
        panel.hidden = true;
        panel.innerHTML = '';
      }
      if (input) input.setAttribute('aria-expanded', 'false');
    }
    function requestUrl(q) {
      var sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
      return (
        baseUrl +
        sep +
        'q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last'
      );
    }

    document.addEventListener('click', function (e) {
      wraps.forEach(function (wrap) {
        if (wrap.contains(e.target)) return;
        closeWrap(wrap);
      });
    });

    wraps.forEach(function (wrap) {
      var input = qs(wrap, '[data-bh-predictive-input]');
      var panel = qs(wrap, '[data-bh-predictive-panel]');
      if (!input || !panel) return;
      var searchBase = wrap.getAttribute('data-bh-search-url') || '/search';
      var msgEmpty = wrap.getAttribute('data-msg-no-results') || 'No matching products';
      var msgViewAll = wrap.getAttribute('data-msg-view-all') || 'View all results';
      var abort;

      function debounce(fn, ms) {
        var t;
        return function () {
          clearTimeout(t);
          var args = arguments;
          t = setTimeout(function () {
            fn.apply(null, args);
          }, ms);
        };
      }

      function renderProducts(products, query) {
        if (!products || !products.length) {
          return '<div class="bh-predictive-panel__empty">' + escapeHtml(msgEmpty) + '</div>';
        }
        var rows = products.map(function (p) {
          var imgUrl =
            p.featured_image && p.featured_image.url
              ? p.featured_image.url
              : p.image || '';
          var title = escapeHtml(p.title);
          var price = escapeHtml(formatMoney(p.price));
          var url = p.url || '#';
          var support = resolveSupportStrength({ title: p.title });
          var supportHtml = support
            ? supportBadgeHtml(support, 'search')
            : '';
          return (
            '<a role="option" class="bh-predictive-panel__row" href="' +
            escapeAttr(url) +
            '">' +
            (imgUrl
              ? '<span class="bh-predictive-panel__thumb"><img src="' +
                escapeAttr(imgUrl) +
                '" alt="" width="56" height="56" loading="lazy"></span>'
              : '<span class="bh-predictive-panel__thumb bh-predictive-panel__thumb--empty" aria-hidden="true"></span>') +
            '<span class="bh-predictive-panel__meta"><span class="bh-predictive-panel__title">' +
            title +
            '</span>' +
            (supportHtml
              ? '<span class="bh-predictive-panel__support">' + supportHtml + '</span>'
              : '') +
            '<span class="bh-predictive-panel__price">' +
            price +
            '</span></span></a>'
          );
        });
        var qSep = searchBase.indexOf('?') === -1 ? '?' : '&';
        var viewHref = searchBase + qSep + 'q=' + encodeURIComponent(query);
        var footer =
          '<a class="bh-predictive-panel__footer" href="' +
          escapeAttr(viewHref) +
          '">' +
          escapeHtml(msgViewAll) +
          '</a>';
        return '<div class="bh-predictive-panel__scroll">' + rows.join('') + '</div>' + footer;
      }

      var runSearch = debounce(function () {
        var q = (input.value || '').trim();
        if (q.length < 1) {
          closeWrap(wrap);
          return;
        }
        if (abort) abort.abort();
        abort = typeof AbortController !== 'undefined' ? new AbortController() : null;
        fetch(requestUrl(q), { signal: abort ? abort.signal : undefined })
          .then(function (r) {
            if (!r.ok) throw new Error(String(r.status));
            return r.json();
          })
          .then(function (data) {
            var products =
              data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.products
                ? data.resources.results.products
                : [];
            panel.innerHTML = renderProducts(products, q);
            panel.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            closeWrap(wrap);
          });
      }, 200);

      input.addEventListener('input', runSearch);
      input.addEventListener('focus', function () {
        if ((input.value || '').trim().length >= 1) runSearch();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeWrap(wrap);
          input.blur();
        }
      });
      panel.addEventListener('mousedown', function (e) {
        e.preventDefault();
      });
    });
  }

  function initValueCarousels(root) {
    qsa(root || document, '[data-value-carousel]').forEach(function (wrap) {
      var track = qs(wrap, '[data-value-track]');
      var slides = track ? qsa(track, '.bh-value-carousel__slide') : [];
      var prev = qs(wrap, '[data-value-prev]');
      var next = qs(wrap, '[data-value-next]');
      var dotsRoot = wrap.parentElement && qs(wrap.parentElement, '[data-value-dots]');
      if (!track || slides.length < 2) return;

      var index = 0;
      function go(n) {
        index = Math.max(0, Math.min(n, slides.length - 1));
        var slide = slides[index];
        if (slide) {
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
        if (dotsRoot) {
          qsa(dotsRoot, 'button').forEach(function (d, j) {
            d.classList.toggle('is-active', j === index);
          });
        }
      }

      if (dotsRoot) {
        dotsRoot.innerHTML = '';
        slides.forEach(function (_, j) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bh-value-carousel__dot' + (j === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Slide ' + (j + 1));
          dot.addEventListener('click', function () {
            go(j);
          });
          dotsRoot.appendChild(dot);
        });
      }

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
    });
  }

  function initCollectionCategoryStrip() {
    qsa(document, '[data-coll-cats]').forEach(function (root) {
      var wrap = qs(root, '.bh-coll-cats__wrap') || root;
      var track = qs(root, '[data-coll-cats-track]');
      var prev = qs(root, '[data-coll-cats-prev]');
      var next = qs(root, '[data-coll-cats-next]');
      if (!track) return;

      function syncCentered() {
        var overflows = track.scrollWidth > track.clientWidth + 2;
        wrap.classList.toggle('is-centered', !overflows);
        if (prev) prev.hidden = !overflows;
        if (next) next.hidden = !overflows;
      }

      function scrollByDir(dir) {
        var amount = Math.max(track.clientWidth * 0.7, 180);
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
      if (next) next.addEventListener('click', function () { scrollByDir(1); });

      syncCentered();
      window.addEventListener('resize', debounce(syncCentered, 150));
      if ('ResizeObserver' in window) {
        new ResizeObserver(syncCentered).observe(track);
      }
    });
  }

  function initCollectionStickyToolbar() {
    var wrap = qs(document, '[data-collection-toolbar-sticky]');
    var header = qs(document, '.section-header');
    if (!wrap || !header) return;

    function setHeaderOffset() {
      document.documentElement.style.setProperty('--bh-header-offset', header.offsetHeight + 'px');
    }
    setHeaderOffset();
    window.addEventListener('resize', debounce(setHeaderOffset, 150));

    var sentinel = document.createElement('div');
    sentinel.className = 'bh-collection-toolbar-sentinel';
    wrap.parentNode.insertBefore(sentinel, wrap);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            wrap.classList.toggle('is-stuck', !entry.isIntersecting);
          });
        },
        { root: null, threshold: 0, rootMargin: '-' + header.offsetHeight + 'px 0px 0px 0px' }
      );
      observer.observe(sentinel);
    }
  }

  function initCollectionDrawers() {
    var filtersDrawer = qs(document, '[data-filters-drawer]');
    var sortDrawer = qs(document, '[data-sort-drawer]');

    function setBodyLock(locked) {
      document.documentElement.style.overflow = locked ? 'hidden' : '';
      document.body.style.overflow = locked ? 'hidden' : '';
    }

    function openDrawer(drawer) {
      if (!drawer) return;
      drawer.hidden = false;
      setBodyLock(true);
    }

    function closeDrawer(drawer) {
      if (!drawer) return;
      drawer.hidden = true;
      if ((!filtersDrawer || filtersDrawer.hidden) && (!sortDrawer || sortDrawer.hidden)) {
        setBodyLock(false);
      }
    }

    qsa(document, '[data-open-filters]').forEach(function (btn) {
      btn.addEventListener('click', function () { openDrawer(filtersDrawer); });
    });
    qsa(document, '[data-close-filters]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeDrawer(filtersDrawer); });
    });
    qsa(document, '[data-open-sort]').forEach(function (btn) {
      btn.addEventListener('click', function () { openDrawer(sortDrawer); });
    });
    qsa(document, '[data-close-sort]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeDrawer(sortDrawer); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeDrawer(filtersDrawer);
      closeDrawer(sortDrawer);
    });

    qsa(document, '[data-collection-sort]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.form) input.form.submit();
      });
    });
  }

  function initCollectionFacets() {
    var facets = qsa(document, '[data-bh-facet]');
    if (!facets.length) return;

    qsa(document, '.bh-facet__checkbox').forEach(function (input) {
      function syncOption() {
        var opt = input.closest('.bh-facet__option');
        if (opt) opt.classList.toggle('is-active', input.checked);
      }
      input.addEventListener('change', syncOption);
      syncOption();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncScrollLock();
    initBhPredictiveSearch();
    initCollectionFacets();
    initCollectionDrawers();
    initCollectionStickyToolbar();
    initCollectionCategoryStrip();
    initValueCarousels(document);
    initAllProductCardSwatches(document);
    initQuickView();
    qsa(document, '[data-bh-product]').forEach(initBhProduct);
    fetchCart().then(function (cart) {
      renderCart(cart);
      var countEls = qsa(document, '[data-cart-count]');
      var n = cart.item_count || 0;
      countEls.forEach(function (el) {
        el.textContent = n > 99 ? '99+' : String(n);
        el.hidden = n === 0;
      });
    }).catch(function () {});
  });

  /* Newsletter popup */
  var popup = qs(document, '[data-newsletter-popup]');
  if (popup) {
    var dismissed = 'bh-newsletter-dismissed';
    var subscribed = 'bh-newsletter-subscribed';
    function openPopup() {
      if (localStorage.getItem(subscribed) || localStorage.getItem(dismissed)) return;
      setTimeout(function () {
        popup.classList.add('is-open');
      }, 2500);
    }
    function closePopup() {
      popup.classList.remove('is-open');
      try {
        localStorage.setItem(dismissed, '1');
      } catch (e) {}
    }
    openPopup();
    qsa(document, '[data-newsletter-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        popup.classList.add('is-open');
      });
    });
    qsa(popup, '[data-newsletter-close]').forEach(function (b) {
      b.addEventListener('click', closePopup);
    });
    var backdropP = qs(popup, '[data-newsletter-backdrop]');
    if (backdropP) backdropP.addEventListener('click', closePopup);
    var form = qs(popup, '#NewsletterPopupForm') || qs(popup, 'form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        var action = form.getAttribute('action') || '/contact';
        fetch(action, {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(function () {
            try {
              localStorage.setItem(subscribed, '1');
              localStorage.setItem(dismissed, '1');
            } catch (err) {}
            var thanks = qs(popup, '[data-newsletter-thanks]');
            var main = qs(popup, '[data-newsletter-main]');
            if (thanks) thanks.hidden = false;
            if (main) main.hidden = true;
            setTimeout(closePopup, 2200);
          })
          .catch(function () {
            form.submit();
          });
      });
    }
  }
})();
